import React from 'react';

import { token } from '@/theme';

const ValueIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="ChartBar">
        <path
          id="Vector"
          d="M3.75 16.25V10.625H7.5"
          stroke={color ?? token.colorText}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M17.5 16.25H2.5"
          stroke={color ?? token.colorText}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M7.5 16.25V6.875H11.875"
          stroke={color ?? token.colorText}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M11.875 16.25V3.125H16.25V16.25"
          stroke={color ?? token.colorText}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export default ValueIcon;
